import React, { useEffect, useRef } from "react";
import { Input, InputRef } from "antd";

export const OTP_LENGTH = 6;

/**
 * One box for the 6-digit authenticator code: digits only, spaces/dashes stripped (apps show
 * "123 456"), auto-submits when the 6th digit is in. Keeps focus so the user can type straight away.
 */
const OtpInput: React.FC<{
  value: string;
  onChange: (v: string) => void;
  onComplete: (v: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  size?: "large" | "middle";
}> = ({ value, onChange, onComplete, disabled, autoFocus = true, size = "large" }) => {
  const ref = useRef<InputRef>(null);
  useEffect(() => { if (autoFocus) setTimeout(() => ref.current?.focus(), 50); }, [autoFocus]);
  const set = (raw: string) => {
    const v = raw.replace(/\D/g, "").slice(0, OTP_LENGTH);
    onChange(v);
    if (v.length === OTP_LENGTH) onComplete(v);
  };
  return (
    <Input
      ref={ref}
      size={size}
      value={value}
      disabled={disabled}
      inputMode="numeric"
      autoComplete="one-time-code"
      pattern="[0-9]*"
      maxLength={OTP_LENGTH + 1}
      placeholder="000000"
      onChange={(e) => set(e.target.value)}
      onPaste={(e) => { e.preventDefault(); set(e.clipboardData.getData("text")); }}
      onPressEnter={() => { if (value.length === OTP_LENGTH) onComplete(value); }}
      style={{ letterSpacing: 10, textAlign: "center", fontSize: 22, fontVariantNumeric: "tabular-nums", maxWidth: 240 }}
    />
  );
};

export default OtpInput;
